<template>
	<div class="employee_project_detail">
		<form autocomplete="off" @submit.prevent="handleSubmit">
      <div class="project_employee_wrapper">
        <div class="project_detail_catalog">
          <h3 class="project_detail_catalog__name">PM</h3>
        </div>
        <div class="project_detail_form_wrapper">
          <div
            class="project_detail_form set-border'"
          >
            <div class="project_detail_input">
              <label class="project_detail_input__label">
                {{ $t("project_management.project_detail.input_label.employee_name") }}
                <span class="required">*</span>
              </label>
              <Select2
                v-model="pm[0].id"
                :options="pm"
                disabled
              />
            </div>
            <div class="project_detail_input">
              <label class="project_detail_input__label">
                {{ $t("project_management.project_detail.input_label.employee_position") }}
                <span class="required">*</span>
              </label>
              <Select2 :value="0" :options="pmType" disabled/>
            </div>
            <div class="date_range_wrapper">
              <div class="date_range_container">
                <div class="project_detail_input">
                  <label class="project_detail_input__label">
                    {{ $t("project_management.project_detail.input_label.employee_start_date") }}
                    <span class="required">*</span>
                  </label>
                  <DatePicker
                    v-model="projectDetail.start_date"
                    :disabled="true"
                    format="DD/MM/YYYY"
                    placeholder="DD/MM/YYYY"
                    value-type="format"
                  />
                </div>
                <div class="project_detail_input">
                  <label class="project_detail_input__label">
                    {{ $t("project_management.project_detail.input_label.employee_end_date") }}
                    <span class="required">*</span>
                  </label>
                  <DatePicker
                    v-model="projectDetail.end_date"
                    :disabled="true"
                    format="DD/MM/YYYY"
                    placeholder="DD/MM/YYYY"
                    value-type="format"/>
                </div>
                <div class="delete_button_wrapper">
                  <div class="btn_add_wrapper">
                    <div class="empty_block"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
			<div class="project_employee_wrapper">
				<div class="project_detail_catalog">
						<h3 class="project_detail_catalog__name">BrSE</h3>
				</div>
				<div class="project_detail_form_wrapper">
					<div
						v-for="(employee, ind) in project.employeeBrSE"
						:key="employee.id"
						class="project_detail_form"
						:class="[ind === 0 ? '' : 'set-border']"
					>
						<div class="project_detail_input">
							<label class="project_detail_input__label" for="project_name">
								{{ $t("project_management.project_detail.input_label.employee_name") }}
								<span class="required">*</span>
							</label>
							<Select2
								v-model="employee.employee_id"
								:options="employeeList"
								@change="onChangeEmployee()"
							/>
							<div v-for="error of $v.project.$errors" :key="error.$uid">
								<div v-if="error.$property === 'employeeBrSE' && error.$response.$errors.length > 0">
									<div
										v-if="error.$response.$errors[ind].employee_id.length > 0 && !(employee.numberOfSubmit == numberOfSubmit)"
										class="validation_error">
										Nhân viên {{
											$t("fields.project_detail.validation." + error.$response.$errors[ind].employee_id[0].$validator)
										}}
									</div>
								</div>
							</div>
							<div class="delete_button_wrapper" @click="removeEmployee(ind, 'employeeBrSE')">
								<div class="btn_add_wrapper">
									<div>
										<img class="plus_icon" src="@/assets/icons/trash.svg"/>
										{{ $t("project_management.project_detail.button_title.remove_employee") }}
									</div>
								</div>
							</div>
						</div>
						<div class="project_detail_input">
							<label class="project_detail_input__label" for="project_cost">
								{{ $t("project_management.project_detail.input_label.employee_position") }}
								<span class="required">*</span>
							</label>
							<Select2 v-model="employee.employee_type" :options="positionListBrSE"/>
							<div v-for="error of $v.project.$errors" :key="error.$uid">
								<div v-if="error.$property === 'employeeBrSE' && error.$response.$errors.length > 0">
									<div
										v-if="error.$response.$errors[ind].employee_type.length > 0  && !(employee.numberOfSubmit == numberOfSubmit)"
										class="validation_error">
										Vị trí {{
											$t("fields.project_detail.validation." + error.$response.$errors[ind].employee_type[0].$validator)
										}}
									</div>
								</div>
							</div>
						</div>
						<div class="date_range_wrapper">
							<div v-for="(date, index) in employee.date_range" :key="index"
										class="date_range_container">
								<div class="project_detail_input">
									<label class="project_detail_input__label" for="project_cost">
										{{ $t("project_management.project_detail.input_label.employee_start_date") }}
										<span class="required">*</span>
									</label>
									<DatePicker
										v-model="date.start_date"
										:clearable="false"
										format="DD/MM/YYYY"
										placeholder="DD/MM/YYYY"
										value-type="format"
									/>
									<div v-for="error of $v.project.$errors" :key="error.$uid">
										<div
											v-if="error.$property === 'employeeBrSE' &&  error.$response.$errors[ind].date_range.length  > 0">
											<div
												v-if="error.$response.$errors[ind].date_range[0].$response.$errors[index].start_date.length > 0  && !(employee.numberOfSubmit == numberOfSubmit)"
												class="validation_error">
												Thời gian bắt đầu {{
													$t("fields.project_detail.validation." + error.$response.$errors[ind].date_range[0].$response.$errors[index].start_date[0].$validator)
												}}
											</div>
										</div>
									</div>
								</div>
								<div class="project_detail_input">
									<label class="project_detail_input__label" for="project_cost">
										{{ $t("project_management.project_detail.input_label.employee_end_date") }}
										<span class="required">*</span>
									</label>
									<DatePicker
										v-model="date.end_date"
										:clearable="false"
										format="DD/MM/YYYY"
										placeholder="DD/MM/YYYY"
										value-type="format"/>
									<div v-for="error of $v.project.$errors" :key="error.$uid">
										<div
											v-if="error.$property === 'employeeBrSE' &&  error.$response.$errors[ind].date_range.length  > 0">
											<div
												v-if="error.$response.$errors[ind].date_range[0].$response.$errors[index].end_date.length > 0  && !(employee.numberOfSubmit == numberOfSubmit)"
												class="validation_error">
												Thời gian kết thúc {{
													$t("fields.project_detail.validation." + error.$response.$errors[ind].date_range[0].$response.$errors[index].end_date[0].$validator)
												}}
											</div>
										</div>
									</div>
								</div>
								<div class="delete_button_wrapper">
									<div :class="[ index > 0 ? '' : 'pointer_none' ]"
												class="btn_add_wrapper"
												@click="removeDateRange(ind, index, 'employeeBrSE')">
										<img v-if="index > 0" class="plus_icon" src="@/assets/icons/trash.svg"/>
										<div v-else class="empty_block"></div>
									</div>
								</div>
							</div>
							<div class="btn_add_wrapper">
								<img class="plus_icon" src="@/assets/icons/icon_plus.svg" @click="addRangeTime(ind, 'employeeBrSE')"/>
								<h3 class="btn_add__title" @click="addRangeTime(ind, 'employeeBrSE')">{{
										$t("project_management.project_detail.button_title.add_range_time")
									}}</h3>
							</div>
						</div>
					</div>
					<div class="border-bottom"/>
					<div class="btn_add_wrapper">
						<img class="plus_icon" src="@/assets/icons/icon_plus.svg" @click="addEmployee('employeeBrSE')"/>
						<h3 class="btn_add__title" @click="addEmployee('employeeBrSE')">{{
								$t("project_management.project_detail.button_title.add_employee")
							}}</h3>
					</div>
				</div>
			</div>
			<div class="project_employee_wrapper">
				<div class="project_detail_catalog">
					<h3 class="project_detail_catalog__name">Developer</h3>
				</div>
				<div class="project_detail_form_wrapper">
					<div v-for="(employee, ind) in project.employeeDeveloper" :key="employee.id" class="project_detail_form" :class="[ind === 0 ? '' : 'set-border']">
						<div class="project_detail_input">
							<label class="project_detail_input__label" for="project_name">
								{{ $t("project_management.project_detail.input_label.employee_name") }}
								<span class="required">*</span>
							</label>
							<Select2
								v-model="employee.employee_id"
								:options="employeeList"
								@change="onChangeEmployee()"
							/>
							<div v-for="error of $v.project.$errors" :key="error.$uid">
								<div v-if="error.$property === 'employeeDeveloper' && error.$response.$errors.length > 0">
									<div
										v-if="error.$response.$errors[ind].employee_id.length > 0 && !(employee.numberOfSubmit == numberOfSubmit)"
										class="validation_error">
										Nhân viên {{
											$t("fields.project_detail.validation." + error.$response.$errors[ind].employee_id[0].$validator)
										}}
									</div>
								</div>
							</div>
							<div class="delete_button_wrapper" @click="removeEmployee(ind, 'employeeDeveloper')">
								<div class="btn_add_wrapper">
									<div>
										<img class="plus_icon" src="@/assets/icons/trash.svg"/>
										{{ $t("project_management.project_detail.button_title.remove_employee") }}
									</div>
								</div>
							</div>
						</div>
						<div class="project_detail_input">
							<label class="project_detail_input__label" for="project_cost">
								{{ $t("project_management.project_detail.input_label.employee_position") }}
								<span class="required">*</span>
							</label>
							<Select2 v-model="employee.employee_type" :options="positionListDeveloper"/>
							<div v-for="error of $v.project.$errors" :key="error.$uid">
								<div v-if="error.$property === 'employeeDeveloper' && error.$response.$errors.length > 0">
									<div
										v-if="error.$response.$errors[ind].employee_type.length > 0 && !(employee.numberOfSubmit == numberOfSubmit)"
										class="validation_error">
										Vị trí {{
											$t("fields.project_detail.validation." + error.$response.$errors[ind].employee_type[0].$validator)
										}}
									</div>
								</div>
							</div>
						</div>
						<div class="date_range_wrapper">
							<div v-for="(date, index) in employee.date_range" :key="index"
										class="date_range_container">
								<div class="project_detail_input">
									<label class="project_detail_input__label" for="project_cost">
										{{ $t("project_management.project_detail.input_label.employee_start_date") }}
										<span class="required">*</span>
									</label>
									<DatePicker
										v-model="date.start_date"
										:clearable="false"
										format="DD/MM/YYYY"
										placeholder="DD/MM/YYYY"
										value-type="format"
									/>
									<div v-for="error of $v.project.$errors" :key="error.$uid">
										<div
											v-if="error.$property === 'employeeDeveloper' &&  error.$response.$errors[ind].date_range.length  > 0">
											<div
												v-if="error.$response.$errors[ind].date_range[0].$response.$errors[index].start_date.length > 0 && !(employee.numberOfSubmit == numberOfSubmit)"
												class="validation_error">
												Thời gian bắt đầu {{
													$t("fields.project_detail.validation." + error.$response.$errors[ind].date_range[0].$response.$errors[index].start_date[0].$validator)
												}}
											</div>
										</div>
									</div>
								</div>
								<div class="project_detail_input">
									<label class="project_detail_input__label" for="project_cost">
										{{ $t("project_management.project_detail.input_label.employee_end_date") }}
										<span class="required">*</span>
									</label>
									<DatePicker
										v-model="date.end_date"
										:clearable="false"
										format="DD/MM/YYYY"
										placeholder="DD/MM/YYYY"
										value-type="format"/>
									<div v-for="error of $v.project.$errors" :key="error.$uid">
										<div
											v-if="error.$property === 'employeeDeveloper' &&  error.$response.$errors[ind].date_range.length  > 0">
											<div
												v-if="error.$response.$errors[ind].date_range[0].$response.$errors[index].end_date.length > 0 && !(employee.numberOfSubmit == numberOfSubmit)"
												class="validation_error">
												Thời gian kết thúc {{
													$t("fields.project_detail.validation." + error.$response.$errors[ind].date_range[0].$response.$errors[index].end_date[0].$validator)
												}}
											</div>
										</div>
									</div>
								</div>
								<div class="delete_button_wrapper">
									<div :class="[ index > 0 ? '' : 'pointer_none' ]"
												class="btn_add_wrapper"
												@click="removeDateRange(ind, index, 'employeeDeveloper')">
										<img v-if="index > 0" class="plus_icon" src="@/assets/icons/trash.svg"/>
										<div v-else class="empty_block"></div>
									</div>
								</div>
							</div>
							<div class="btn_add_wrapper">
								<img class="plus_icon" src="@/assets/icons/icon_plus.svg" @click="addRangeTime(ind, 'employeeDeveloper')"/>
								<h3 class="btn_add__title" @click="addRangeTime(ind, 'employeeDeveloper')">{{
										$t("project_management.project_detail.button_title.add_range_time")
									}}</h3>
							</div>
						</div>
					</div>
					<div class="border-bottom"/>
					<div class="btn_add_wrapper">
						<img class="plus_icon" src="@/assets/icons/icon_plus.svg" @click="addEmployee('employeeDeveloper')"/>
						<h3 class="btn_add__title" @click="addEmployee('employeeDeveloper')">{{
								$t("project_management.project_detail.button_title.add_employee")
							}}</h3>
					</div>
				</div>
			</div>
			<div class="project_employee_wrapper">
				<div class="project_detail_catalog">
					<h3 class="project_detail_catalog__name">QA</h3>
				</div>
				<div class="project_detail_form_wrapper">
					<div v-for="(employee, ind) in project.employeeQA" :key="employee.id" class="project_detail_form" :class="[ind === 0 ? '' : 'set-border']">
						<div class="project_detail_input">
							<label class="project_detail_input__label" for="project_name">
								{{ $t("project_management.project_detail.input_label.employee_name") }}
								<span class="required">*</span>
							</label>
							<Select2
								v-model="employee.employee_id"
								:options="employeeList"
								@change="onChangeEmployee()"
							/>
							<div v-for="error of $v.project.$errors" :key="error.$uid">
								<div v-if="error.$property === 'employeeQA' && error.$response.$errors.length > 0">
									<div
										v-if="error.$response.$errors[ind].employee_id.length > 0 && !(employee.numberOfSubmit == numberOfSubmit)"
										class="validation_error">
										Nhân viên {{
											$t("fields.project_detail.validation." + error.$response.$errors[ind].employee_id[0].$validator)
										}}
									</div>
								</div>
							</div>
							<div class="delete_button_wrapper" @click="removeEmployee(ind, 'employeeQA')">
								<div class="btn_add_wrapper">
									<div>
										<img class="plus_icon" src="@/assets/icons/trash.svg"/>
										{{ $t("project_management.project_detail.button_title.remove_employee") }}
									</div>
								</div>
							</div>
						</div>
						<div class="project_detail_input">
							<label class="project_detail_input__label" for="project_cost">
								{{ $t("project_management.project_detail.input_label.employee_position") }}
								<span class="required">*</span>
							</label>
							<Select2 v-model="employee.employee_type" :options="positionListQA"/>
							<div v-for="error of $v.project.$errors" :key="error.$uid">
								<div v-if="error.$property === 'employeeQA' && error.$response.$errors.length > 0">
									<div
										v-if="error.$response.$errors[ind].employee_type.length > 0 && !(employee.numberOfSubmit == numberOfSubmit)"
										class="validation_error">
										Vị trí {{
											$t("fields.project_detail.validation." + error.$response.$errors[ind].employee_type[0].$validator)
										}}
									</div>
								</div>
							</div>
						</div>
						<div class="date_range_wrapper">
							<div v-for="(date, index) in employee.date_range" :key="index"
										class="date_range_container">
								<div class="project_detail_input">
									<label class="project_detail_input__label" for="project_cost">
										{{ $t("project_management.project_detail.input_label.employee_start_date") }}
										<span class="required">*</span>
									</label>
									<DatePicker
										v-model="date.start_date"
										:clearable="false"
										format="DD/MM/YYYY"
										placeholder="DD/MM/YYYY"
										value-type="format"
									/>
									<div v-for="error of $v.project.$errors" :key="error.$uid">
										<div
											v-if="error.$property === 'employeeQA' &&  error.$response.$errors[ind].date_range.length  > 0">
											<div
												v-if="error.$response.$errors[ind].date_range[0].$response.$errors[index].start_date.length > 0 && !(employee.numberOfSubmit == numberOfSubmit)"
												class="validation_error">
												Thời gian bắt đầu {{
													$t("fields.project_detail.validation." + error.$response.$errors[ind].date_range[0].$response.$errors[index].start_date[0].$validator)
												}}
											</div>
										</div>
									</div>
								</div>
								<div class="project_detail_input">
									<label class="project_detail_input__label" for="project_cost">
										{{ $t("project_management.project_detail.input_label.employee_end_date") }}
										<span class="required">*</span>
									</label>
									<DatePicker
										v-model="date.end_date"
										:clearable="false"
										format="DD/MM/YYYY"
										placeholder="DD/MM/YYYY"
										value-type="format"/>
									<div v-for="error of $v.project.$errors" :key="error.$uid">
										<div
											v-if="error.$property === 'employeeQA' &&  error.$response.$errors[ind].date_range.length  > 0">
											<div
												v-if="error.$response.$errors[ind].date_range[0].$response.$errors[index].end_date.length > 0 && !(employee.numberOfSubmit == numberOfSubmit)"
												class="validation_error">
												Thời gian kết thúc {{
													$t("fields.project_detail.validation." + error.$response.$errors[ind].date_range[0].$response.$errors[index].end_date[0].$validator)
												}}
											</div>
										</div>
									</div>
								</div>
								<div class="delete_button_wrapper">
									<div :class="[ index > 0 ? '' : 'pointer_none' ]"
												class="btn_add_wrapper"
												@click="removeDateRange(ind, index, 'employeeQA')">
										<img v-if="index > 0" class="plus_icon" src="@/assets/icons/trash.svg"/>
										<div v-else class="empty_block"></div>
									</div>
								</div>
							</div>
							<div class="btn_add_wrapper">
								<img class="plus_icon" src="@/assets/icons/icon_plus.svg" @click="addRangeTime(ind, 'employeeQA')"/>
								<h3 class="btn_add__title" @click="addRangeTime(ind, 'employeeQA')">{{
										$t("project_management.project_detail.button_title.add_range_time")
									}}</h3>
							</div>
						</div>
					</div>
					<div class="border-bottom"/>
					<div class="btn_add_wrapper">
						<img class="plus_icon" src="@/assets/icons/icon_plus.svg" @click="addEmployee('employeeQA')"/>
						<h3 class="btn_add__title" @click="addEmployee('employeeQA')">{{
								$t("project_management.project_detail.button_title.add_employee")
							}}</h3>
					</div>
				</div>
			</div>
			<div class="project_employee_wrapper">
				<div class="project_detail_catalog">
					<h3 class="project_detail_catalog__name">Other</h3>
				</div>
				<div class="project_detail_form_wrapper">
					<div v-for="(employee, ind) in project.employeeOther" :key="employee.id" class="project_detail_form" :class="[ind === 0 ? '' : 'set-border']">
						<div class="project_detail_input">
							<label class="project_detail_input__label" for="project_name">
								{{ $t("project_management.project_detail.input_label.employee_name") }}
								<span class="required">*</span>
							</label>
							<Select2
								v-model="employee.employee_id"
								:options="employeeList"
								@change="onChangeEmployee()"
							/>
							<div v-for="error of $v.project.$errors" :key="error.$uid">
								<div v-if="error.$property === 'employeeOther' && error.$response.$errors.length > 0">
									<div
										v-if="error.$response.$errors[ind].employee_id.length > 0 && !(employee.numberOfSubmit == numberOfSubmit)"
										class="validation_error">
										Nhân viên {{
											$t("fields.project_detail.validation." + error.$response.$errors[ind].employee_id[0].$validator)
										}}
									</div>
								</div>
							</div>
							<div class="delete_button_wrapper" @click="removeEmployee(ind, 'employeeOther')">
								<div class="btn_add_wrapper">
									<div>
										<img class="plus_icon" src="@/assets/icons/trash.svg"/>
										{{ $t("project_management.project_detail.button_title.remove_employee") }}
									</div>
								</div>
							</div>
						</div>
						<div class="project_detail_input">
							<label class="project_detail_input__label" for="project_cost">
								{{ $t("project_management.project_detail.input_label.employee_position") }}
								<span class="required">*</span>
							</label>
							<Select2 v-model="employee.employee_type" :options="positionListOther"/>
							<div v-for="error of $v.project.$errors" :key="error.$uid">
								<div v-if="error.$property === 'employeeOther' && error.$response.$errors.length > 0">
									<div
										v-if="error.$response.$errors[ind].employee_type.length > 0 && !(employee.numberOfSubmit == numberOfSubmit)"
										class="validation_error">
										Vị trí {{
											$t("fields.project_detail.validation." + error.$response.$errors[ind].employee_type[0].$validator)
										}}
									</div>
								</div>
							</div>
						</div>
						<div class="date_range_wrapper">
							<div v-for="(date, index) in employee.date_range" :key="index"
										class="date_range_container">
								<div class="project_detail_input">
									<label class="project_detail_input__label" for="project_cost">
										{{ $t("project_management.project_detail.input_label.employee_start_date") }}
										<span class="required">*</span>
									</label>
									<DatePicker
										v-model="date.start_date"
										:clearable="false"
										format="DD/MM/YYYY"
										placeholder="DD/MM/YYYY"
										value-type="format"
									/>
									<div v-for="error of $v.project.$errors" :key="error.$uid">
										<div
											v-if="error.$property === 'employeeOther' &&  error.$response.$errors[ind].date_range.length  > 0">
											<div
												v-if="error.$response.$errors[ind].date_range[0].$response.$errors[index].start_date.length > 0 && !(employee.numberOfSubmit == numberOfSubmit)"
												class="validation_error">
												Thời gian bắt đầu {{
													$t("fields.project_detail.validation." + error.$response.$errors[ind].date_range[0].$response.$errors[index].start_date[0].$validator)
												}}
											</div>
										</div>
									</div>
								</div>
								<div class="project_detail_input">
									<label class="project_detail_input__label" for="project_cost">
										{{ $t("project_management.project_detail.input_label.employee_end_date") }}
										<span class="required">*</span>
									</label>
									<DatePicker
										v-model="date.end_date"
										:clearable="false"
										format="DD/MM/YYYY"
										placeholder="DD/MM/YYYY"
										value-type="format"/>
									<div v-for="error of $v.project.$errors" :key="error.$uid">
										<div
											v-if="error.$property === 'employeeOther' &&  error.$response.$errors[ind].date_range.length  > 0">
											<div
												v-if="error.$response.$errors[ind].date_range[0].$response.$errors[index].end_date.length > 0 && !(employee.numberOfSubmit == numberOfSubmit)"
												class="validation_error">
												Thời gian kết thúc {{
													$t("fields.project_detail.validation." + error.$response.$errors[ind].date_range[0].$response.$errors[index].end_date[0].$validator)
												}}
											</div>
										</div>
									</div>
								</div>
								<div class="delete_button_wrapper">
									<div :class="[ index > 0 ? '' : 'pointer_none' ]"
												class="btn_add_wrapper"
												@click="removeDateRange(ind, index, 'employeeOther')">
										<img v-if="index > 0" class="plus_icon" src="@/assets/icons/trash.svg"/>
										<div v-else class="empty_block"></div>
									</div>
								</div>
							</div>
							<div class="btn_add_wrapper">
								<img class="plus_icon" src="@/assets/icons/icon_plus.svg" @click="addRangeTime(ind, 'employeeOther')"/>
								<h3 class="btn_add__title" @click="addRangeTime(ind, 'employeeOther')">{{
										$t("project_management.project_detail.button_title.add_range_time")
									}}</h3>
							</div>
						</div>
					</div>
					<div class="border-bottom"/>
					<div class="btn_add_wrapper">
						<img class="plus_icon" src="@/assets/icons/icon_plus.svg" @click="addEmployee('employeeOther')"/>
						<h3 class="btn_add__title" @click="addEmployee('employeeOther')">{{
								$t("project_management.project_detail.button_title.add_employee")
							}}</h3>
					</div>
				</div>
			</div>
			<div class="btn_wrapper">
				<button class="btn_submit" type="submit">
					{{ $t("project_management.project_detail.button_title.submit") }}
				</button>
				<button class="btn_cancel" type="button" @click="onBack">
					{{ $t("project_management.project_detail.button_title.cancel") }}
				</button>
			</div>
		</form>
	</div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import Select2 from "v-select2-component";
import {mapGetters, mapActions} from "vuex";
import useVuelidate from "@vuelidate/core";
import {required, helpers} from '@vuelidate/validators'
import moment from "moment";

export default {
  name: "ProjectDetail",
  setup() {
    return {
      $v: useVuelidate(),
    }
  },
  data() {
    return {
      id: this.$route.params.id,
      project: {},
      pm: [],
      pmType: [{id:0, text:'PM'}],
      dateRange: [],
      // oddClass: "odd",
      // evenClass: "even",
      messages: {
        required: "{attribute} là bắt buộc",
        before_or_equal: "Thời gian bắt đầu phải nhỏ hơn hoặc bằng ngày kết thúc"
      },
	  numberOfSubmit: 0
      // defaultDateValue: new Date(),
      // selectedEmployees: []
    }
  },
  components: {
    DatePicker,
    Select2,
  },
  computed: {
    ...mapGetters({
      projectDetail: "projectManagement/project",
      employeeList: "projectManagement/employees",
      positionList: "projectManagement/positions",
    }),
		positionListBrSE() {
			return this.positionList.filter(item => ['PreBrSE', 'BRSE'].includes(item.id));
		},
		positionListDeveloper() {
			let data = this.positionList.filter(item => ['DEV', 'PL'].includes(item.id));
			return data;
		},
		positionListQA() {
			let data = this.positionList.filter(item => ['QA', 'QA_LEAD'].includes(item.id));
			return data;
		},
		positionListOther() {
			let data = this.positionList.filter(item => !['PreBrSE', 'BRSE', 'DEV', 'PL', 'QA', 'QA_LEAD'].includes(item.id));
			return data;
		}
  },
  validations() {
		return {
			project: {
				employeeBrSE: {
					$each: helpers.forEach({
						employee_id: {
							required
						},
						employee_type: {
							required,
						},
						date_range: {
							required,
							$each: helpers.forEach({
								start_date: {
									required,
									date_equal_or_before(value, object) {
										return moment(value, "DD/MM/YYYY").isSameOrBefore(moment(object.end_date, "DD/MM/YYYY"));
									},
									date_after(value, object, index, array) {
										if (array.date_range[index - 1] !== undefined) {
											return moment(array.date_range[index - 1].end_date, "DD/MM/YYYY").isBefore(moment(value, "DD/MM/YYYY"));
										} else {
											return true;
										}
									},
									date_equal_or_after_project_start_date(value, object) {
										return moment(value, "DD/MM/YYYY").isSameOrAfter(moment(this.projectDetail.start_date, "DD/MM/YYYY"));
									},
								},
								end_date: {
									required,
									date_equal_or_before_project_end_date(value, object) {
										return moment(value, "DD/MM/YYYY").isSameOrBefore(moment(this.projectDetail.end_date, "DD/MM/YYYY"));
									},
									// date_equal_or_before_project_end_date(value, object) {
									//   let lastElement = this.project.project_labo_payments.slice(-1);
									//   console.log(lastElement)
									//   if (lastElement !== undefined) {
									//     return moment(value, "DD/MM/YYYY").isSameOrBefore(moment(lastElement.end_date, "DD/MM/YYYY"));
									//   } else {
									//     return true;
									//   }
									// }
								}
							}),
						}
					})
				},
				employeeDeveloper: {
					$each: helpers.forEach({
						employee_id: {
							required
						},
						employee_type: {
							required,
						},
						date_range: {
							required,
							$each: helpers.forEach({
								start_date: {
									required,
									date_equal_or_before(value, object) {
										return moment(value, "DD/MM/YYYY").isSameOrBefore(moment(object.end_date, "DD/MM/YYYY"));
									},
									date_after(value, object, index, array) {
										if (array.date_range[index - 1] !== undefined) {
											return moment(array.date_range[index - 1].end_date, "DD/MM/YYYY").isBefore(moment(value, "DD/MM/YYYY"));
										} else {
											return true;
										}
									},
									date_equal_or_after_project_start_date(value, object) {
										return moment(value, "DD/MM/YYYY").isSameOrAfter(moment(this.projectDetail.start_date, "DD/MM/YYYY"));
									},
								},
								end_date: {
									required,
									date_equal_or_before_project_end_date(value, object) {
										return moment(value, "DD/MM/YYYY").isSameOrBefore(moment(this.projectDetail.end_date, "DD/MM/YYYY"));
									},
									// date_equal_or_before_project_end_date(value, object) {
									//   let lastElement = this.project.project_labo_payments.slice(-1);
									//   console.log(lastElement)
									//   if (lastElement !== undefined) {
									//     return moment(value, "DD/MM/YYYY").isSameOrBefore(moment(lastElement.end_date, "DD/MM/YYYY"));
									//   } else {
									//     return true;
									//   }
									// }
								}
							}),
						}
					})
				},
				employeeQA: {
					$each: helpers.forEach({
						employee_id: {
							required
						},
						employee_type: {
							required,
						},
						date_range: {
							required,
							$each: helpers.forEach({
								start_date: {
									required,
									date_equal_or_before(value, object) {
										return moment(value, "DD/MM/YYYY").isSameOrBefore(moment(object.end_date, "DD/MM/YYYY"));
									},
									date_after(value, object, index, array) {
										if (array.date_range[index - 1] !== undefined) {
											return moment(array.date_range[index - 1].end_date, "DD/MM/YYYY").isBefore(moment(value, "DD/MM/YYYY"));
										} else {
											return true;
										}
									},
									date_equal_or_after_project_start_date(value, object) {
										return moment(value, "DD/MM/YYYY").isSameOrAfter(moment(this.projectDetail.start_date, "DD/MM/YYYY"));
									},
								},
								end_date: {
									required,
									date_equal_or_before_project_end_date(value, object) {
										return moment(value, "DD/MM/YYYY").isSameOrBefore(moment(this.projectDetail.end_date, "DD/MM/YYYY"));
									},
									// date_equal_or_before_project_end_date(value, object) {
									//   let lastElement = this.project.project_labo_payments.slice(-1);
									//   console.log(lastElement)
									//   if (lastElement !== undefined) {
									//     return moment(value, "DD/MM/YYYY").isSameOrBefore(moment(lastElement.end_date, "DD/MM/YYYY"));
									//   } else {
									//     return true;
									//   }
									// }
								}
							}),
						}
					})
				},
				employeeOther: {
					$each: helpers.forEach({
						employee_id: {
							required
						},
						employee_type: {
							required,
						},
						date_range: {
							required,
							$each: helpers.forEach({
								start_date: {
									required,
									date_equal_or_before(value, object) {
										return moment(value, "DD/MM/YYYY").isSameOrBefore(moment(object.end_date, "DD/MM/YYYY"));
									},
									date_after(value, object, index, array) {
										if (array.date_range[index - 1] !== undefined) {
											return moment(array.date_range[index - 1].end_date, "DD/MM/YYYY").isBefore(moment(value, "DD/MM/YYYY"));
										} else {
											return true;
										}
									},
									date_equal_or_after_project_start_date(value, object) {
										return moment(value, "DD/MM/YYYY").isSameOrAfter(moment(this.projectDetail.start_date, "DD/MM/YYYY"));
									},
								},
								end_date: {
									required,
									date_equal_or_before_project_end_date(value, object) {
										return moment(value, "DD/MM/YYYY").isSameOrBefore(moment(this.projectDetail.end_date, "DD/MM/YYYY"));
									},
									// date_equal_or_before_project_end_date(value, object) {
									//   let lastElement = this.project.project_labo_payments.slice(-1);
									//   console.log(lastElement)
									//   if (lastElement !== undefined) {
									//     return moment(value, "DD/MM/YYYY").isSameOrBefore(moment(lastElement.end_date, "DD/MM/YYYY"));
									//   } else {
									//     return true;
									//   }
									// }
								}
							}),
						}
					})
				}
			}
		}
  },
  created() {
    this.initial()
  },
  methods: {
    ...mapActions("layout", ["setLoading"]),
    async handleSubmit() {
		this.$v.$touch();
		if (this.$v.$error) {
			this.numberOfSubmit += 1;
			return;
		}
		this.setLoading(true);
		let data = [...this.project['employeeBrSE'], ...this.project['employeeDeveloper'], ...this.project['employeeQA'], ...this.project['employeeOther']]
		const response = await this.$store.dispatch("projectManagement/updateProjectEmployee", {
			data: data,
			id: this.id
		});
		if (response.status === 200) {
			let message = this.$t("additional_timeSheet.message_update_success");
			this.$toast(message, "Thông báo", 2000, "b-toaster-top-center", "success");
			this.$emit("reset-tab-active");
		} else {
			let message = this.$t("additional_timeSheet.message_update_failed");
			this.$toast(message, "Thông báo", 2000, "b-toaster-top-center", "danger");
		}
    },
    convertDateFormat(date) {
      return moment(date, "DD/MM/YYYY").toDate();
    },
    onBack() {
		this.$emit("reset-tab-active");
    },
    addRangeTime(index, type) {
      this.project[type][index].date_range.push({
        start_date: null,
        end_date: null
      });
    },
    removeDateRange(i, index, type)  {
      this.project[type][i].date_range.splice(index, 1);
    },
    addEmployee(type) {
      this.project[type].push({
        employee_id: "",
        employee_type: "",
        date_range: [{
          project_id: this.id,
          start_date: null,
          end_date: null
        }],
		numberOfSubmit: this.numberOfSubmit
      });
    },
    removeEmployee(index, type) {
      this.project[type].splice(index, 1);
      this.getEmployeeList();
    },
    onChangeEmployee() {
      this.getEmployeeList();
    },
    getDefaultProject() {
      this.project = {
        employeeBrSE: this.projectDetail.employeeBrSE.length > 0 ? this.projectDetail.employeeBrSE : [],
        employeeDeveloper: this.projectDetail.employeeDeveloper.length > 0 ? this.projectDetail.employeeDeveloper : [],
        employeeQA: this.projectDetail.employeeQA.length > 0 ? this.projectDetail.employeeQA : [],
        employeeOther: this.projectDetail.employeeOther.length > 0 ? this.projectDetail.employeeOther : [],
      }
      this.project.employeeBrSE.forEach(employee => {
        if (employee.date_range.length === 0) {
          employee.date_range.push({start_date: null, end_date: null})
        }
      })
			this.project.employeeDeveloper.forEach(employee => {
        if (employee.date_range.length === 0) {
          employee.date_range.push({start_date: null, end_date: null})
        }
      })
			this.project.employeeQA.forEach(employee => {
        if (employee.date_range.length === 0) {
          employee.date_range.push({start_date: null, end_date: null})
        }
      })
			this.project.employeeOther.forEach(employee => {
        if (employee.date_range.length === 0) {
          employee.date_range.push({start_date: null, end_date: null})
        }
      })
    },
    getEmployeeList() {
		let arrayProjectEmployee = [...this.project.employeeBrSE, ...this.project.employeeDeveloper, ...this.project.employeeQA, ...this.project.employeeOther]
		let projectEmployees = arrayProjectEmployee.map(employee => employee.employee_id).filter(employee_id => employee_id !== null || true);
		let employeeOptions = this.employeeList.map(employee => {
      if (employee.id === this.projectDetail.pm) {
        this.pm = [employee];
      }
        if (projectEmployees.includes(employee.id)) {
          employee.disabled = true;
          employee.selected = true;
        } else {
          employee.disabled = false;
          employee.selected = false;
        }
        return employee;
      }).filter(employee => {
        return parseInt(employee.id) !== parseInt(this.projectDetail.pm)
      })
      this.$store.dispatch("projectManagement/updateEmployeeList", employeeOptions);
    },
    async initial() {
    //   await this.$store.dispatch("projectManagement/getProjectDetail", this.id)
      await this.$store.dispatch("projectManagement/getEmployeeList");
      await this.$store.dispatch("projectManagement/getPositionList");
      this.getDefaultProject();
      this.getEmployeeList();
    }
  },
}
</script>

<style lang="scss" scoped>
.employee_project_detail {
  // Common CSS
  background: #FFFFFF;
	padding: 0px 30px;

  .pointer_none {
    pointer-events: none;
  }

  .empty_block {
    width: 31px;
    height: 31px;
  }

  .common_padding {
    padding: 20px 30px;
  }

  .common_input {
    background: #FFFFFF;
    border: 1px solid #CFCFCF;
    border-radius: 5px;
    padding: 10px;

    &:focus {
      color: #768192;
      background-color: #fff;
      border-color: #958bef;
      outline: 0;
    }
  }

  .common_icon {
    width: 16px;
    height: 16px;
    cursor: pointer;
  }

  .required {
    color: #F03D3E;
  }

  .text-align-center {
    text-align: center;
  }


  .common_table {
    @extend .common_padding;

    .ptable {
      --border: 1px solid #EFEFEF;
      border-radius: 10px;
      border-spacing: 0;
      border-collapse: separate;
      border: var(--border);
      border-top: 0;
      overflow: hidden;

      & th:not(:last-child),
      & td:not(:last-child) {
        border-right: var(--border);
      }

      & > thead > tr:not(:last-child) > th,
      & > thead > tr:not(:last-child) > td,
      & > tbody > tr:not(:last-child) > th,
      & > tbody > tr:not(:last-child) > td,
      & > tfoot > tr:not(:last-child) > th,
      & > tfoot > tr:not(:last-child) > td,
      & > tr:not(:last-child) > td,
      & > tr:not(:last-child) > th,
      & > thead:not(:last-child),
      & > tbody:not(:last-child),
      & > tfoot:not(:last-child) {
        border-bottom: var(--border);
      }

      &__thead {
        padding: 1em;
        background: #3488EB;
        border-radius: 10px 10px 0px 0px;

        th {
          @extend .text-align-center;
          font-style: normal;
          font-weight: 700;
          font-size: 14px;
          line-height: 17px;
          color: #FFFFFF;
          border-bottom: 0 !important;
          border-right: 1px solid;
        }
      }

      &__tbody {
        padding: 1em;

        th {
          font-style: normal;
          font-weight: 400;
          font-size: 14px;
          line-height: 17px;
          color: #303C54;
          border: 1px solid #EFEFEF;
          vertical-align: baseline;
        }

        td {
          font-style: normal;
          font-weight: 400;
          font-size: 14px;
          line-height: 17px;
          color: #303C54;
          border: 1px solid #EFEFEF;
          vertical-align: baseline;
        }
      }
    }
  }

  .btn_add_wrapper {
    display: flex;
    align-items: center;
    width: 100%;
    margin-top: 10px;

    .plus_icon {
      width: 31px;
      height: 31px;
      background: #F1F1F1;
      padding: 8px;
      border-radius: 50%;
      cursor: pointer;
    }

    .btn_add__title {
      font-style: normal;
      font-weight: 500;
      font-size: 14px;
      line-height: 17px;
      color: #303C54;
      margin-left: 10px;
      margin-bottom: 0;
      cursor: pointer;
    }
  }

  .validation_error {
    color: #F03D3E;
    text-align: left;
    display: flex;
    align-items: center;
  }

  .project_detail_catalog {
    width: 100%;
    background: #EDEDED;
    padding: 13px 30px;
		border-radius: 10px 10px 0 0;
		background: #E7F2FF;

    &__name {
      margin: 0;
      font-style: normal;
      font-weight: 700;
      font-size: 16px;
      line-height: 20px;
      color: #3488EB;
    }
  }

  .project_detail_form {
		padding: 20px 0px;
    display: flex;
    //justify-content: space-between;

    .project_detail_input {
      flex: 1 1 50%;
      margin-right: 22px;

      &__label {
        width: 100%;
        font-style: normal;
        font-weight: 700;
        font-size: 14px;
        line-height: 20px;
        color: #303C54;
        margin-bottom: 8px;
      }

      &__input {
        @extend .common_input;
        width: 100%;
        height: 40px;
      }

      @media screen and (max-width: 1024px) {
        margin-right: 0;
      }
      .mx-datepicker, .disabled {
        background-color: inherit !important;
        border: 0 !important;
        /deep/input {
          color: #444;
        }
      }
    }

    @media screen and (max-width: 1024px) {
      display: block;
    }
  }

  .odd {
    background-color: #293462;
    text-align: center;
    vertical-align: middle !important;
  }

  .even {
    background-color: #1EBE71;
    text-align: center;
    vertical-align: middle !important;
  }

  .disabled {
    background: #F0F0F0 !important;
    border: 1px solid #CFCFCF !important;
    border-radius: 5px !important;
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 16px;
    color: #303C54;
  }

  .project_employee_wrapper {
		border: 1px solid #E7E7E7;
		border-radius: 10px;
		margin-bottom: 20px;

    .project_detail_form_wrapper {
      padding: 20px 30px;

			.set-border {
				border-top: 1px solid #CFCFCF;
			}

      .project_detail_form {
        padding: 20 0 27 0px;

        .date_range_wrapper {
          flex: 1 1 100%;

          .date_range_container {
            display: flex;
            margin-bottom: 10px;

            .empty_block {
              width: 31px;
              height: 31px;
            }
          }
        }
      }

			.border-bottom {
				height: 1px;
    		background-color: black;
    		margin: 0 -30px 20px -30px;
			}

      .delete_button_wrapper {
        display: flex;
        align-items: baseline;
				margin-top: 20px;
				color: #FF6464;

        .btn_add_wrapper {
          margin-top: 0;
          cursor: pointer;

          .plus_icon {
            width: 35px;
            height: 35px;
          }

          .empty_block {
            width: 35px;
            height: 35px;
            pointer-events: none;
          }
        }
      }

      .date_range_wrapper {
        padding-right: 30px;

        .delete_button_wrapper {
          margin-top: 30px;

          .plus_icon {
            width: 31px;
            height: 31px;
          }
        }
      }
    }
  }

  .btn_wrapper {
    width: 100%;
    display: flex;
    justify-content: center;
    padding: 10px 30px 10px 30px;

    .btn_submit {
      width: 172px;
      height: 49px;
      border-radius: 5px;
      font-style: normal;
      font-weight: 500;
      font-size: 14px;
      text-align: center;
      color: #fff;
      background: #118FA6;
      border: 1px solid #118FA6;
      margin-right: 20px;

      &:focus {
        outline: none;
      }
    }

    .btn_cancel {
      width: 172px;
      height: 49px;
      background: #FFFFFF;
      border: 1px solid #6E7A8B;
      border-radius: 5px;
      font-style: normal;
      font-weight: 500;
      font-size: 14px;
      text-align: center;
      color: #1F2D3D;

      &:focus {
        outline: none;
      }
    }
  }
}
</style>

<style lang="scss" scoped>
  /deep/ .mx-datepicker {
    width: 100% !important;
    height: 40px;

    .mx-input-wrapper {
      height: 100% !important;

      .mx-input {
        height: 100% !important;


        &:focus {
          color: #768192;
          background-color: #fff;
          border-color: #958bef;
          outline: 0;
        }

        &:hover {
          background-color: #fff;
          border-color: #958bef;
          outline: 0;
        }
      }

      .mx-icon-calendar {
        svg {
          color: black;
        }
      }

      @media screen and (min-width: 1024px) {
        &:first-of-type {
          margin-right: 10px;
        }
      }
    }
  }

  /deep/ .select2 {
    width: 100% !important;

    &-selection {
      border: 1px solid #CFCFCF !important;
      height: 40px !important;

      &__rendered {
        height: 100% !important;
        vertical-align: middle !important;
        display: flex !important;
        align-items: center !important;
      }

      &__arrow {
        height: 100% !important;
      }
    }
  }
</style>
